import { COMPANY, PHONE } from "@/lib/siteConfig";
import { LegalPage, LegalSection, LegalSubheading } from "@/components/landing/LegalPage";

export default function AGB() {
  return (
    <LegalPage
      eyebrow="Rechtliches"
      title="Allgemeine Geschäftsbedingungen"
      intro="Bedingungen für die Erbringung von Security-Staging-Leistungen (Installation, Vermietung und Betrieb von Alarmanlagen in leerstehenden Immobilien) durch Security Staging, Inhaber Andreas Schössow."
      metaDescription={`Allgemeine Geschäftsbedingungen (AGB) von ${COMPANY.name} für Security-Staging-Dienstleistungen deutschlandweit.`}
      testId="agb-page"
    >
      <LegalSection title="§ 1 Geltungsbereich">
        <p>
          (1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB“) gelten für alle Verträge zwischen{" "}
          <strong className="text-slate-900">{COMPANY.name}</strong>, Inhaber {COMPANY.owner}, {COMPANY.street}, {COMPANY.postalCode} {COMPANY.city} (nachfolgend „Anbieter“) und dem Kunden über die Planung, Installation, Vermietung, Wartung und den Rückbau von Alarmanlagen und Sicherheitskomponenten im Rahmen des sogenannten „Security Staging“.
        </p>
        <p>
          (2) Abweichende, entgegenstehende oder ergänzende Allgemeine Geschäftsbedingungen des Kunden werden nur dann und insoweit Vertragsbestandteil, als der Anbieter ihrer Geltung ausdrücklich schriftlich zugestimmt hat.
        </p>
        <p>
          (3) Kunde im Sinne dieser AGB sind sowohl Verbraucher (§ 13 BGB) als auch Unternehmer (§ 14 BGB). Soweit einzelne Regelungen nur für Verbraucher oder nur für Unternehmer gelten, ist dies ausdrücklich gekennzeichnet.
        </p>
      </LegalSection>

      <LegalSection title="§ 2 Vertragsschluss">
        <p>
          (1) Die Darstellung der Leistungen auf der Webseite{" "}
          <span className="text-slate-900 font-semibold">securitystaging.de</span> stellt kein rechtlich bindendes Angebot, sondern eine unverbindliche Aufforderung an den Kunden dar, dem Anbieter ein Angebot zu unterbreiten.
        </p>
        <p>
          (2) Der Vertrag kommt zustande durch (i) telefonische, per E-Mail oder schriftlich erfolgte Anfrage des Kunden, (ii) individuelles Angebot des Anbieters und (iii) Annahme dieses Angebots durch den Kunden in Textform oder schlüssiges Verhalten (z. B. Terminvereinbarung zur Installation).
        </p>
        <p>
          (3) Der Vertragstext wird nach Vertragsschluss vom Anbieter gespeichert; die AGB in ihrer jeweils gültigen Fassung sind auf der Webseite abrufbar.
        </p>
      </LegalSection>

      <LegalSection title="§ 3 Leistungsumfang">
        <LegalSubheading>3.1 Security Staging</LegalSubheading>
        <p>
          Der Anbieter erbringt insbesondere folgende Leistungen:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Beratung und Planung eines Sicherheitskonzepts für leerstehende Immobilien</li>
          <li>Lieferung und Installation von Funk-Alarmanlagen inklusive Sensorik (u. a. Bewegungsmelder, Tür-/Fensterkontakte, Wasser-, Rauchmelder, Sirenen, optional IP-Kameras)</li>
          <li>Einrichtung der App-Steuerung und Übergabe an den Kunden</li>
          <li>Optional: Rückbau der Anlage oder Übernahme durch den Käufer der Immobilie</li>
        </ul>

        <LegalSubheading>3.2 Konkrete Ausgestaltung</LegalSubheading>
        <p>
          Der konkrete Leistungsumfang ergibt sich aus dem individuellen Angebot bzw. Auftrag. Der Anbieter ist berechtigt, technisch gleichwertige oder verbesserte Komponenten einzusetzen, sofern dies für den Kunden zumutbar ist.
        </p>

        <LegalSubheading>3.3 Mitwirkung des Kunden</LegalSubheading>
        <p>
          Der Kunde stellt sicher, dass er berechtigt ist, Sicherheitstechnik im betreffenden Objekt anzubringen (z. B. als Eigentümer, mit Vollmacht des Eigentümers oder Genehmigung des Vermieters). Er sorgt für Zugang zum Objekt und einen funktionsfähigen Stromanschluss.
        </p>
      </LegalSection>

      <LegalSection title="§ 4 Preise und Zahlungsbedingungen">
        <p>
          (1) Es gelten die im individuellen Angebot ausgewiesenen Preise. Alle Preise verstehen sich zuzüglich der jeweils gesetzlichen Umsatzsteuer, sofern nicht ausdrücklich als Brutto ausgewiesen. Kleinunternehmerregelung nach § 19 UStG gilt, sofern zutreffend.
        </p>
        <p>
          (2) Sofern nichts anderes vereinbart ist, sind Rechnungen innerhalb von 14 Tagen nach Rechnungsdatum ohne Abzug zur Zahlung fällig.
        </p>
        <p>
          (3) Bei Zahlungsverzug ist der Anbieter berechtigt, Verzugszinsen in gesetzlicher Höhe (§ 288 BGB) zu berechnen. Die Geltendmachung eines weitergehenden Schadens bleibt vorbehalten.
        </p>
        <p>
          (4) Aufrechnungsrechte stehen dem Kunden nur zu, wenn seine Gegenansprüche rechtskräftig festgestellt oder unbestritten sind.
        </p>
      </LegalSection>

      <LegalSection title="§ 5 Termine und Ausführung">
        <p>
          (1) Installationstermine werden individuell vereinbart. Termine sind für den Anbieter nur verbindlich, wenn sie schriftlich (auch per E-Mail) bestätigt wurden.
        </p>
        <p>
          (2) Bei höherer Gewalt, Lieferengpässen bei Herstellern, behördlichen Anordnungen oder anderen vom Anbieter nicht zu vertretenden Umständen verlängern sich Fristen angemessen. Der Anbieter informiert den Kunden unverzüglich.
        </p>
      </LegalSection>

      <LegalSection title="§ 6 Eigentumsvorbehalt / Miet-Modell">
        <p>
          (1) Bei Kauf-Leistungen bleibt die gelieferte Sicherheitstechnik bis zur vollständigen Zahlung des Kaufpreises Eigentum des Anbieters.
        </p>
        <p>
          (2) Sofern die Anlage im Rahmen eines Miet- bzw. Nutzungsmodells bereitgestellt wird, bleibt sie durchgehend Eigentum des Anbieters. Der Kunde erhält lediglich ein Nutzungsrecht für die Vertragsdauer. Nach Vertragsende erfolgt der spurlose Rückbau durch den Anbieter oder – bei entsprechender Vereinbarung – die Übernahme durch den neuen Eigentümer der Immobilie.
        </p>
      </LegalSection>

      <LegalSection title="§ 7 Widerrufsrecht für Verbraucher">
        <LegalSubheading>Widerrufsbelehrung</LegalSubheading>
        <p>
          <strong>Widerrufsrecht:</strong> Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt 14 Tage ab dem Tag des Vertragsabschlusses.
        </p>
        <p>
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns ({COMPANY.name}, {COMPANY.street}, {COMPANY.postalCode} {COMPANY.city}, Telefon {PHONE.display}, E-Mail{" "}
          <a
            href={`mailto:${COMPANY.email}`}
            className="text-[#0A2340] font-semibold underline underline-offset-4 hover:text-[#EAB308]"
          >
            {COMPANY.email}
          </a>
          ) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
        </p>
        <p>
          <strong>Folgen des Widerrufs:</strong> Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen 14 Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.
        </p>
        <p>
          <strong>Vorzeitiges Erlöschen des Widerrufsrechts:</strong> Das Widerrufsrecht erlischt bei einem Vertrag zur Erbringung von Dienstleistungen, wenn der Anbieter die Dienstleistung vollständig erbracht hat und mit der Ausführung der Dienstleistung erst begonnen hat, nachdem der Verbraucher dazu seine ausdrückliche Zustimmung gegeben und gleichzeitig seine Kenntnis davon bestätigt hat, dass er sein Widerrufsrecht bei vollständiger Vertragserfüllung durch den Unternehmer verliert.
        </p>
      </LegalSection>

      <LegalSection title="§ 8 Gewährleistung">
        <p>
          (1) Für gelieferte Sachen gelten die gesetzlichen Gewährleistungsrechte. Gegenüber Unternehmern beträgt die Gewährleistungsfrist 12 Monate ab Übergabe; gegenüber Verbrauchern gelten die gesetzlichen Fristen.
        </p>
        <p>
          (2) Der Anbieter leistet Gewähr für die fachgerechte Installation der Alarmanlage. Nicht umfasst ist Verschleiß, unsachgemäße Bedienung, Beschädigung durch Dritte oder Eingriffe durch nicht autorisierte Personen.
        </p>
      </LegalSection>

      <LegalSection title="§ 9 Haftung">
        <p>
          (1) Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.
        </p>
        <p>
          (2) Bei leichter Fahrlässigkeit haftet der Anbieter nur bei Verletzung einer wesentlichen Vertragspflicht (Kardinalpflicht), deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren Einhaltung der Kunde regelmäßig vertrauen darf. Die Haftung ist in diesem Fall auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
        </p>
        <p>
          (3) Eine weitergehende Haftung ist ausgeschlossen. Insbesondere übernimmt der Anbieter keine Garantie dafür, dass durch die Alarmanlage jegliche Einbrüche, Vandalismus, Wasser- oder Brandschäden verhindert werden. Die Alarmanlage stellt eine unterstützende Maßnahme dar; die Verantwortung für die allgemeine Objektsicherung verbleibt beim Kunden.
        </p>
        <p>
          (4) Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.
        </p>
      </LegalSection>

      <LegalSection title="§ 10 Datenschutz">
        <p>
          Der Anbieter verarbeitet personenbezogene Daten des Kunden ausschließlich im Rahmen der geltenden Datenschutzgesetze. Einzelheiten sind der{" "}
          <a
            href="/datenschutz"
            className="text-[#0A2340] font-semibold underline underline-offset-4 hover:text-[#EAB308]"
          >
            Datenschutzerklärung
          </a>{" "}
          zu entnehmen.
        </p>
      </LegalSection>

      <LegalSection title="§ 11 Gerichtsstand und anwendbares Recht">
        <p>
          (1) Für sämtliche Rechtsbeziehungen zwischen dem Anbieter und dem Kunden gilt ausschließlich deutsches Recht unter Ausschluss des UN-Kaufrechts (CISG).
        </p>
        <p>
          (2) Bei Verträgen mit Unternehmern, juristischen Personen des öffentlichen Rechts oder öffentlich-rechtlichen Sondervermögen ist ausschließlicher Gerichtsstand Dortmund.
        </p>
        <p>
          (3) Gegenüber Verbrauchern gilt der gesetzliche Gerichtsstand.
        </p>
      </LegalSection>

      <LegalSection title="§ 12 Schlussbestimmungen">
        <p>
          (1) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, so bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. An die Stelle der unwirksamen Bestimmung tritt die gesetzliche Regelung.
        </p>
        <p>
          (2) Änderungen und Ergänzungen dieser AGB bedürfen der Textform. Dies gilt auch für die Änderung dieser Textformklausel selbst.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
